import { Component } from '@angular/core';
import {FormsModule} from "@angular/forms";
import {FormLabelDirective} from "../../../core/directives/form-label.directive";
import {FormInputTextDirective} from "../../../core/directives/form-input-text.directive";
import {RouterLink} from "@angular/router";
import {NgIf} from "@angular/common";
import { AuthService } from '../../../services/auth.service';
import {GlobalConfig, ToastrService} from "ngx-toastr";
import {AlertToast} from "../../../shared/notifications/alert.toast";
import {NgxSpinnerService} from "ngx-spinner";

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [
    FormsModule,
    FormLabelDirective,
    FormInputTextDirective,
    RouterLink,
    NgIf
  ],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.css'
})
export class ForgotPasswordComponent {
  loading: boolean = false;
  options: GlobalConfig;

  email: string = "";
  successMessage: string| null = null;

  constructor(
    private authService: AuthService,
    private toastr: ToastrService,
    private spinner: NgxSpinnerService,
   ) {
    this.options = this.toastr.toastrConfig;

  }

  restore(){
    this.loadingFunc(true);
    this.authService.sendPasswordResetLink(this.email).subscribe({
      next: result => {
        this.successMessage = 'Enlace de restablecimiento de contraseña enviado con éxito, siga las instrucciones de su correo.';
        this.forgotPasswordSuccessToast('Restablezca su contraseña', this.successMessage);
      },
      error: error => {
        this.forgotPasswordErrorToast('Error', 'Error en el envío del email para el reseteo de la contraseña');
        this.loadingFunc(false);
      },
      complete: () => {
        this.loadingFunc(false);
      },
    });
  }

  loadingFunc(loading: boolean) {
    this.loading = loading;
    loading ? this.spinner.show() : this.spinner.hide();
  }

  forgotPasswordErrorToast(title: string, message: string) {
    const opt: any = this.options;
    opt.toastComponent = AlertToast;
    opt.progressBar = true;
    opt.type = 'error';
    opt.toastClass = 'toast';
    this.toastr.show(message, title, opt);
  }

  forgotPasswordSuccessToast(title: string, message: string) {
    const opt: any = this.options;
    opt.toastComponent = AlertToast;
    opt.progressBar = true;
    opt.type = 'success';
    opt.toastClass = 'toast';
    this.toastr.show(message, title, opt);
  }
}
